module.exports = "<div data-bind=\"visible: visible\" class=box-tips> <div class=box-tip-text> <i class=\"fa fa-question-circle-o\"></i> <span data-bind=\"text: tipText\"></span> </div> <div class=box-tip> <ul data-bind=\"foreach: tipList\"> <li data-bind=\"text: $data\"></li> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/box-tips/index.html
// module id = 435
// module chunks = 144